/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.recommended_payroll_as[_ngcontent-%COMP%] {\n    margin: 5px;    \n}\n.recommended_payroll[_ngcontent-%COMP%] {\n    margin-top: 7px;    \n}\n.payroll_id[_ngcontent-%COMP%] {\n    font-size: 12px;\n    color: #bababc;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1wYXlyb2xsL2Jvb2tpbmctcGF5cm9sbC5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3ZlcmNlbC93b3JrcGF0aDAvc3JjL2FwcC9ib29raW5nLW1hbmFnZW1lbnQvYm9va2luZy1wYXlyb2xsL2Jvb2tpbmctcGF5cm9sbC5jb21wb25lbnQudHMiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// ./src/$$_gendir/app/booking-management/booking-payroll/booking-payroll.component.css.shim.ngstyle.ts